/**
 * Script de limpieza de base de datos para ejecutar desde la consola del navegador
 * Uso: window.cleanDatabase()
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función global para limpiar la base de datos según especificaciones
(window as any).cleanDatabase = async function() {
  console.log('🚀 Iniciando limpieza específica de base de datos...');
  console.log('📋 Especificaciones:');
  console.log('  - Eliminar TODOS los productos');
  console.log('  - Eliminar TODAS las marcas');
  console.log('  - Eliminar TODOS los proveedores');
  console.log('  - Eliminar categorías duplicadas (mantener solo una de cada tipo)');
  console.log('  - Mantener estructura de carpetas para enrutamiento futuro');
  
  try {
    // Importar el servicio de limpieza
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    
    // Ejecutar limpieza completa
    const summary = await databaseCleanup.cleanAll();
    
    console.log('✅ Limpieza completada:', summary);
    console.log(`📊 Total eliminado: ${summary.totalDeleted} elementos`);
    console.log(`❌ Total errores: ${summary.totalErrors}`);
    
    // Mostrar resultados detallados
    console.group('📋 Resultados Detallados');
    console.log('Productos:', summary.products);
    console.log('Marcas:', summary.brands);
    console.log('Proveedores:', summary.suppliers);
    console.log('Categorías:', summary.categories);
    console.groupEnd();
    
    return summary;
  } catch (error) {
    console.error('❌ Error en limpieza:', error);
    throw error;
  }
};

// Función para limpiar solo productos
(window as any).cleanProducts = async function() {
  console.log('🧹 Limpiando solo productos...');
  
  try {
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    const result = await databaseCleanup.cleanProducts();
    
    console.log('✅ Productos limpiados:', result);
    return result;
  } catch (error) {
    console.error('❌ Error limpiando productos:', error);
    throw error;
  }
};

// Función para limpiar solo marcas
(window as any).cleanBrands = async function() {
  console.log('🧹 Limpiando solo marcas...');
  
  try {
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    const result = await databaseCleanup.cleanBrands();
    
    console.log('✅ Marcas limpiadas:', result);
    return result;
  } catch (error) {
    console.error('❌ Error limpiando marcas:', error);
    throw error;
  }
};

// Función para limpiar solo proveedores
(window as any).cleanSuppliers = async function() {
  console.log('🧹 Limpiando solo proveedores...');
  
  try {
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    const result = await databaseCleanup.cleanSuppliers();
    
    console.log('✅ Proveedores limpiados:', result);
    return result;
  } catch (error) {
    console.error('❌ Error limpiando proveedores:', error);
    throw error;
  }
};

// Función para limpiar solo categorías duplicadas
(window as any).cleanCategories = async function() {
  console.log('🧹 Limpiando solo categorías duplicadas...');
  
  try {
    const { default: databaseCleanup } = await import('../utils/databaseCleanup');
    const result = await databaseCleanup.cleanCategories();
    
    console.log('✅ Categorías limpiadas:', result);
    return result;
  } catch (error) {
    console.error('❌ Error limpiando categorías:', error);
    throw error;
  }
};

// Función para verificar el estado actual de la base de datos
(window as any).checkDatabaseStatus = async function() {
  console.log('🔍 Verificando estado de la base de datos...');
  
  try {
    if (!window.auth || !window.auth.db) {
      throw new Error('Firebase no está inicializado');
    }
    
    const { collection, getDocs } = window.auth;
    const userId = window.auth.auth.currentUser?.uid;
    
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }
    
    // Verificar productos
    const productsRef = collection(window.auth.db, 'users', userId, 'products');
    const productsSnapshot = await getDocs(productsRef);
    
    // Verificar marcas
    const brandsRef = collection(window.auth.db, 'users', userId, 'brands');
    const brandsSnapshot = await getDocs(brandsRef);
    
    // Verificar proveedores
    const suppliersRef = collection(window.auth.db, 'users', userId, 'suppliers');
    const suppliersSnapshot = await getDocs(suppliersRef);
    
    // Verificar categorías
    const categoriesRef = collection(window.auth.db, 'users', userId, 'categories');
    const categoriesSnapshot = await getDocs(categoriesRef);
    
    const status = {
      products: productsSnapshot.docs.length,
      brands: brandsSnapshot.docs.length,
      suppliers: suppliersSnapshot.docs.length,
      categories: categoriesSnapshot.docs.length,
      total: productsSnapshot.docs.length + brandsSnapshot.docs.length + suppliersSnapshot.docs.length + categoriesSnapshot.docs.length
    };
    
    console.log('📊 Estado actual de la base de datos:', status);
    
    // Verificar duplicados en categorías
    const categoriesByName: { [key: string]: number } = {};
    categoriesSnapshot.docs.forEach((doc: any) => {
      const name = doc.data().name || doc.id;
      categoriesByName[name] = (categoriesByName[name] || 0) + 1;
    });
    
    const duplicates = Object.entries(categoriesByName).filter(([name, count]) => count > 1);
    if (duplicates.length > 0) {
      console.log('⚠️ Categorías duplicadas encontradas:', duplicates);
    } else {
      console.log('✅ No hay categorías duplicadas');
    }
    
    return status;
  } catch (error) {
    console.error('❌ Error verificando estado:', error);
    throw error;
  }
};

console.log('🧹 Scripts de limpieza cargados. Funciones disponibles:');
console.log('- window.cleanDatabase() - Limpieza completa');
console.log('- window.cleanProducts() - Solo productos');
console.log('- window.cleanBrands() - Solo marcas');
console.log('- window.cleanSuppliers() - Solo proveedores');
console.log('- window.cleanCategories() - Solo categorías duplicadas');
console.log('- window.checkDatabaseStatus() - Verificar estado actual');
